module.exports = __webpack_public_path__ + "static/img/7.b993d25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/9/sp/7.png
// module id = xx5C
// module chunks = 0